import { render, staticRenderFns } from "./DocumentRuleWrapper.vue?vue&type=template&id=ceeeec42&scoped=true"
import script from "./DocumentRuleWrapper.vue?vue&type=script&lang=js"
export * from "./DocumentRuleWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceeeec42",
  null
  
)

export default component.exports